<div [class.h-100]="!isApp" class="pb-5">
    <div
        class="card"
        [ngClass]="{ unavailable: !pack.is_available && !pack.is_contracted, contracted: pack.is_contracted }"
        [ngStyle]="{
            'box-shadow': pack.is_contracted ? '0 0 15px 1px' + pack.color : '0 0 15px 1px rgba(0, 0, 0, 0.11)',
            border: (hover || !!isSelected) ? '2px solid ' + pack.color : '2px solid transparent'
        }"
        (mouseover)="hover = true"
        (mouseleave)="hover = false"
    >
        <div *ngIf="!pack.is_available" class="unavailable"></div>

        <div
            class="card-body"
            [ngClass]="{ 'pack-available': pack.is_available || pack.is_contracted }"
            [ngStyle]="{ color: pack.is_available || pack.is_contracted ? pack.color : '#888' }"
        >
            <h1 class="pack-title font-mulish">
                {{ pack.title }}
            </h1>
            <ul class="pack-plafonds list-group d-none d-md-block">
                <li
                    class="list-group-item px-0"
                    *ngFor="let component of pack.components; let i = index"
                    [ngClass]="{
                        'align-items-baseline': component.type === 'numeric',
                        'align-items-center': component.type === 'text',
                        'd-flex justify-content-between': i !== 0,
                        strikethrough: component.status !== '1'
                    }"
                >
                    <ng-container *ngIf="i === 0">
                        <span class="pack-plafonds-value" [ngClass]="{ invisible: !component.value || component.value === '0' }">
                            <span class="text-lowercase">{{ "pt.edp.edponline.pack.ate" | translate }}</span>
                            <span class="amount">&nbsp;{{ component.value }}{{ component.unit }}</span>
                        </span>
                        <span class="pack-plafonds-title text-lowercase" [ngClass]="{ invisible: !component.value || component.value === '0' }">
                            {{ component.title }}
                        </span>
                    </ng-container>
                    <i
                        class="{{ component.category.icon }} align-self-center icon d-none d-md-block"
                        *ngIf="i !== 0"
                        aria-hidden="true"
                    ></i>

                    <span class="align-self-center" *ngIf="component.type === 'numeric' && i !== 0">
                        <span class="pack-plafonds-value">{{ component.value }}{{ component.unit }}&nbsp;</span>
                    </span>

                    <span class="pack-plafonds-title text-left align-self-center" *ngIf="i !== 0">
                        {{ component.title | translate }}&nbsp;&nbsp;
                    </span>

                    <a (click)="showDetails(pack.color, component)" class="d-block d-md-none" *ngIf="i !== 0 && component.status === '1'">
                        <span class="ml-auto isresponsive">
                            <i class="icon icon-edponline-arrow-right" aria-hidden="true"></i>
                        </span>
                    </a>
                </li>
            </ul>

            <ul class="pack-plafonds list-group d-block d-md-none">
                <ng-container *ngFor="let component of pack.components; let i = index; first as isFirst">
                    <li
                        *ngIf="i !== 1"
                        class="list-group-item px-0"
                        [ngClass]="{
                            'align-items-baseline': component.type === 'numeric',
                            'align-items-center': component.type === 'text',
                            'd-flex justify-content-between': i !== 0,
                            strikethrough: component.status !== '1'
                        }"
                    >
                        <ng-container *ngIf="i === 0">
                            <span class="pack-plafonds-value" [ngClass]="{ invisible: !component.value || component.value === '0' }">
                                <span class="text-lowercase">{{ "pt.edp.edponline.pack.ate" | translate }}</span>
                                <span class="amount">&nbsp;{{ component.value }}{{ component.unit }}</span>
                            </span>
                            <span class="pack-plafonds-title text-lowercase" [ngClass]="{ invisible: !component.value || component.value === '0' }">
                                {{ component.title }}
                            </span>
                        </ng-container>
                        <div class="d-inline-flex align-items-center text-left w-100" [ngClass]="{ 'mt-4': isFirst }">
                            <i class="{{ component.category.icon }} icon align-self-start" aria-hidden="true"></i>
                            <a
                                (click)="showDetails(pack.color, component)"
                                class="d-flex pack-link text-left mobile d-flex align-items-center"
                                *ngIf="component.status === '1'"
                            >
                                <span>
                                    {{ component.category.label | translate }}&nbsp;&nbsp;
                                    <br />
                                    <span class="teaser" [innerHTML]="component.description_mobile"></span>
                                </span>
                                <span class="ml-auto">
                                    <i class="icon-edponline-Bra-073 rotate-270" aria-hidden="true"></i>
                                </span>
                            </a>
                            <span *ngIf="component.status !== '1'" class="striketext">{{ component.category.label | translate }}</span>
                        </div>
                    </li>
                </ng-container>
            </ul>

            <div class="mt-5 position-relative">
                <span class="pack-release" *ngIf="pack?.title === 'Full'">
                    {{ "pt.edp.edponline.pack.release" | translate }}
                </span>
                <div class="d-flex justify-content-center align-items-center text-center">
                    <div class="pack-discount mx-1" *ngIf="pack.discount">
                        <s>{{ pack.value | number: "1.2-2":"pt" }}&euro;</s>
                    </div>
                    <div class="pack-cost h4">
                        {{ !!pack.discount ? (pack.discount | number: "1.2-2":"pt") : (pack.value | number: "1.2-2":"pt") }}{{ pack.unit }}
                        <span class="align-self-end mb-1">&nbsp;&euro;/mês</span>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center align-items-center mb-2 text-center">
                <p class="disclaimer">{{ "pt.edp.edponline.pack.fidelizacao" | translate }}</p>
            </div>

            <div class="pack-subscribe">
                <button
                    type="button"
                    class="d-block btn btn-primary text-uppercase"
                    (click)="selectPack(pack)"
                    [appOperationHistory]="'SHOWCASE_SUBSCRIBE'"
                    [newValue]="pack.id_crm"
                    *ngIf="showcase && pack.is_available"
                >
                    {{ "pt.edp.edponline.pack.aderir" | translate }}
                </button>
                <button
                    type="button"
                    class="d-block btn btn-edp-color-neu-06"
                    (click)="selectPack(pack)"
                    *ngIf="!pack.is_available && !pack.is_contracted"
                >
                    {{ "pt.edp.edponline.pack.info" | translate }}
                </button>
                <button
                    type="button"
                    class="d-block btn btn-primary"
                    (click)="selectPack(pack)"
                    *ngIf="!pack.is_available && pack.is_contracted"
                >
                    {{ "pt.edp.edponline.pack.manage" | translate }}
                </button>
            </div>

            <hr [class.d-none]="isCollapsed" [ngStyle]="{ 'background-color': pack.color }" class="d-none d-md-block" />

            <ul class="pack-benefits list-group d-none d-md-block" [collapse]="isCollapsed">
                <li
                    *ngFor="let group of pack.components; let i = index"
                    [id]="pack.id + group.category.title"
                    class="list-group-item px-0"
                    [class.d-none]="i === 1"
                >
                    <span class="align-self-center mt-1 mb-0">
                        <i class="{{ group.category.icon }}" aria-hidden="true"></i>
                    </span>

                    <h6 class="pack-benefits-title mt-0 mb-2">
                        {{ group.category.label | translate }}
                    </h6>

                    <div class="pack-benefits-description not-included w-100 center" *ngIf="group.status !== '1'">
                        <span>
                            {{ "pt.edp.edponline.pack.notincluded" | translate }}
                        </span>
                    </div>

                    <div
                        class="pack-benefits-description"
                        [innerHTML]="group.description"
                        [ngClass]="{ 'center': group.description.length < 34 }"
                        *ngIf="group.status === '1'"
                    ></div>

                    <a
                        *ngIf="!!group.link && i > 0"
                        href="{{ group.link }}"
                        rel="noopener noreferrer"
                        [appOperationHistory]="'SHOWCASE_MORE_INFO'"
                        [newValue]="pack.id_crm"
                        class="d-inline-block pack-link"
                        target="_blank"
                        rel="noopener"
                        [edpExternalLink]="group.link"
                    >
                        <span class="font-mulish font-weight-medium">{{ "pt.edp.edponline.pack.more.info" | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-footer pt-3 pb-5 border-top-0">
            <span class="d-block text-center px-3" [ngStyle]="{ color: pack.color }">
                {{ "pt.edp.edponline.pack.advertising.campaign" | translate }}
            </span>
        </div>
    </div>
</div>
